import Bugsnag from "@bugsnag/js";
import { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import styled from "styled-components";

import { Button } from "./components/common/Buttons";
import FlexBox from "./components/common/FlexBox";
import { H2 } from "./components/common/Headings";
import { logout } from "./Store/Actions";
import { store } from "./Store/configureStore";

const Container = styled(FlexBox)`
  height: 100vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 1.5rem;
`;

const RouteErrorFallback = () => {
  const error = useRouteError();

  useEffect(() => {
    if (error) {
      console.error("Route error:", error);
      Bugsnag.notify(error);
    }
  }, [error]);

  return (
    <Container>
      <H2 bold>Something went wrong</H2>

      <Button onClick={() => (window.location.href = "/dashboard")}>
        Go to Dashboard
      </Button>
      {typeof window !== "undefined" && !window?.ReactNativeWebView && (
        <Button onClick={() => store?.dispatch?.(logout())}>Relogin</Button>
      )}
    </Container>
  );
};

export default RouteErrorFallback;
